import { Alert, Snackbar, Typography } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import CryptoJS from "crypto-js";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { API_IMAGE_URL, CRYPTO_TOKEN_SECRET_KEY } from "../../config";
import { useSidebar } from "../ContextAPI/SidebarContext";
import { getUserData } from "../../Actions/common";
import { getRoleByPermissionAction } from "../../Actions/RoleActions";
import logo from "../../Assets/logo.png";
import DropdownNotification from "../../Sections/Notification/SocketNotification";
import SideBarComponent from "../Common/Sidebar";
import { useUser } from "../ContextAPI/ProfileContext";
import { useSidebarDesk } from "../ContextAPI/SidebarContextDesktop";


const getPermissionData = (key) => {
  const decryptedData = CryptoJS.AES.decrypt(
    localStorage.getItem(key),
    CRYPTO_TOKEN_SECRET_KEY
  ).toString(CryptoJS.enc.Utf8);
  return JSON.parse(decryptedData);
};

const HeaderComponent = ({ sandBoxEvent }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { toggleSidebar } = useSidebar();
  const { userDetails } = useUser();
  const [isSandbox, setIsSandbox] = useState(() => {
    const stored = localStorage.getItem("isSandbox");
    return stored === null ? false : stored === "true";
  });
  const { sidebarDeskOpen, toggleSidebarDesk } = useSidebarDesk();
  const userData = localStorage.getItem("userData") ? getUserData() : null;
  const UserDetailData = userDetails?.data || userDetails;
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });


  const [permission, setPermission] = useState(() =>
    localStorage.getItem(`${userData?.id}_permissionData`)
      ? getPermissionData(`${userData?.id}_permissionData`)
      : []
  );

  const ipWhiteListPermission = permission[0]?.role_permissions?.find(
    (m) => m?.module && m?.module?.slug === "ip-whitelist"
  )?.canView;
  
  const ipBlockedPermission = permission[0]?.role_permissions?.find(
    (m) => m?.module && m?.module?.slug === "ip-blocked"
  )?.canView;

  const templatePermission = permission[0]?.role_permissions?.find(
    (m) => m?.module && m?.module?.slug === "templates"
  )?.canView;

  useEffect(() => {
    localStorage.setItem("isSandbox", isSandbox);
    sandBoxEvent();
  }, [isSandbox,sandBoxEvent]);

  const handleSwitchEnvironment = () => {
    setIsSandbox((prev) => !prev);
  };

  const navigate = useNavigate();

  useEffect(() => {
    if (userData?.roleId) {
      getRoleByPermissionAction(userData.roleId)
        .then((data) => {
          const permData = data?.data?.data ?? [];
          const encryptedPermissionData = CryptoJS.AES.encrypt(
            JSON.stringify(permData),
            CRYPTO_TOKEN_SECRET_KEY
          ).toString();
          localStorage.setItem(
            `${userData?.id}_permissionData`,
            encryptedPermissionData
          );
          // Update state so sidebar re-renders without a page refresh
          setPermission(permData);
        })
        .catch((error) => {
          const parsedErrorData = JSON.parse(error.response.data);
          setSnackbar({
            open: true,
            message: parsedErrorData.message,
            severity: "error",
          });
        });
    }
  }, [userData?.roleId,userData?.id]);


  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleProfileRoutes = (routeName) => {
    if (routeName === "profile") {
      navigate(`/profile`);
    }

    if (routeName === "settings") {
      navigate(`/settings`);
    }

    if (routeName === "login-sessions") {
      navigate(`/login-sessions`);
    }

    if (routeName === "whitelist-ips") {
      navigate(`/whitelist-ips`);
    }

    if (routeName === "templates") {
      navigate(`/templates`);
    }

    if (routeName === "terms-conditions") {
      navigate(`/terms-conditions`);
    }

    if (routeName === "ip-blocked") {
      navigate(`/ip-blocked`);
    }

    if (routeName === "knowledge-base") {
      navigate(`/knowledge-base`);
    }

    setAnchorEl(null);
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("GLOBAL_SETTING");
    localStorage.removeItem("userData");
    localStorage.removeItem(`${userData?.id}_permissionData`);
    // dispatch(logout());
    setAnchorEl(null);
    setSnackbar({
      open: true,
      message: "Logout successfully.",
      severity: "success",
    });
    setTimeout(() => {
      navigate("/login");
    }, 1000);
  };

  const stringAvatar = (profileData) => {
    const firstNameInitial = profileData?.firstName
      ? profileData.firstName.split("")[0]
      : "";
    const lastNameInitial = profileData?.lastName
      ? profileData.lastName.split("")[0]
      : "";

    return {
      children: `${firstNameInitial}${lastNameInitial}`,
    };
  };
  return (
    <>
      {isSandbox && (
        <div
          style={{
            width: "100%",
            background: "#89a6ff",
            color: "#fff",
            padding: "6px 32px",
            textAlign: "center",
            fontWeight: 500,
            fontSize: "16px",
            position: "fixed",
            top: 0,
            left: 0,
            zIndex: 2000,
            borderBottom: "0px solid #fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 8,
          }}
        >
          <span
            style={{
              display: "flex",
              alignItems: "center",
              marginRight: 5,
            }}
          >
            <i
              className="fa-solid fa-flask"
              style={{
                color: "#fff",
                fontSize: 20,
                marginRight: 8,
              }}
            ></i>
          </span>
          <span>
            You are in the sandbox environment.{" "}
            <span
              style={{
                color: "#22419e",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={handleSwitchEnvironment}
            >
              Switch to live environment
            </span>
          </span>
        </div>
      )}

      <div id="kt_header" className={isSandbox ? "header sandbox" : " header "}>
        <div className="header-container w-100 d-flex align-items-center justify-content-between ">
          <div className=" header-humberger ms-0" id="kt_aside_mobile_toggle">
            <Link to="/dashboard" className="w-100 d-flex text-center">
              <img
                src={`${logo}`}
                alt="Qbot Logo"
                className="position-relative m-auto header-logo"
              />
            </Link>
          </div>
          <div className="d-flex align-items-stretch justify-content-between flex-xl-grow-1 w-100">
            <div className="d-flex align-items-center">
            </div>

            <div className="d-flex gap-3">
              <DropdownNotification />
              <div className="d-flex align-items-stretch flex-shrink-0 ">
                <div
                  className="d-flex align-items-center ms-1 ms-3"
                  id="kt_header_user_menu_toggle"
                >
                  <div
                    className="cursor-pointer symbol"
                    data-kt-menu-trigger="click"
                    data-kt-menu-attach="parent"
                    data-kt-menu-placement="bottom-end"
                  >
                    <div className="d-flex align-items-center">
                      <div>
                        <IconButton
                          onClick={handleClick}
                          style={{
                            background: "transparent",
                            padding: 0,
                          }}
                        >
                          <div className="d-none ">
                            <span className="text-dark fs-6 fw-bold lh-1 mb-1">
                              {UserDetailData?.firstName}{" "}
                              {UserDetailData?.lastName}
                            </span>
                            <span className="text-muted fs-7 fw-semibold lh-1">
                              {UserDetailData?.email}
                            </span>
                          </div>
                          <Avatar
                            {...stringAvatar(UserDetailData)}
                            src={`${API_IMAGE_URL}/${UserDetailData?.profilePic}`}
                            className="w-40px h-40px w-xl-50px h-xl-50px rounded-5 bg-primary-subtle text-primary"
                          />
                        </IconButton>
                        <Menu
                          className="custom-menu "
                          sx={{ borderRadius: "20px" }}
                          id="user-profile-menu"
                          anchorEl={anchorEl}
                          open={Boolean(anchorEl)}
                          onClose={handleProfileRoutes}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                        >
                          <MenuItem
                            className="d-flex align-items-center bg-white mx-5 py-5 border-bottom"
                            sx={{ width: 250 }}
                          >
                            <Avatar
                              {...stringAvatar(UserDetailData)}
                              src={`${API_IMAGE_URL}/${UserDetailData?.profilePic}`}
                              className="h-50px w-50px rounded-5 bg-primary-subtle text-primary"
                            />
                            <div className="d-block  ms-5 mt-2">
                              <span className="text-dark fs-5 d-block fw-bold lh-1 mb-1">
                                {UserDetailData?.firstName}{" "}
                                {UserDetailData?.lastName}
                              </span>
                              <span className="text-muted d-block fs-7 fw-semibold lh-1">
                                {UserDetailData?.email}
                              </span>
                            </div>
                          </MenuItem>
                          <MenuItem
                            className="mx-5 rounded-2 fs-5 py-3"
                            onClick={(e) => handleProfileRoutes("profile")}
                          >
                            Profile
                          </MenuItem>
                          {ipWhiteListPermission ? (
                            <MenuItem
                              className="mx-5 rounded-2 fs-5 py-3"
                              onClick={(e) =>
                                handleProfileRoutes("whitelist-ips")
                              }
                            >
                              Whitelist Ips
                            </MenuItem>
                          ) : null}
                          {templatePermission ? (
                            <MenuItem
                              className="mx-5 rounded-2 fs-5 py-3"
                              onClick={(e) => handleProfileRoutes("templates")}
                            >
                              Email Templates
                            </MenuItem>
                          ) : null}
                          <MenuItem
                            className="mx-5 rounded-2 fs-5 py-3"
                            onClick={(e) => handleProfileRoutes("settings")}
                          >
                            Settings
                          </MenuItem>
                          <MenuItem
                            className="mx-5 rounded-2 fs-5 py-3"
                            onClick={(e) =>
                              handleProfileRoutes("login-sessions")
                            }
                          >
                            Login Sessions
                          </MenuItem>
                          <MenuItem
                            className="mx-5 rounded-2 fs-5 py-3"
                            onClick={(e) =>
                              handleProfileRoutes("knowledge-base")
                            }
                          >
                            Knowledge Base
                          </MenuItem>
                          <MenuItem
                            className="mx-5 rounded-2 fs-5 py-3"
                            onClick={(e) =>
                              handleProfileRoutes("terms-conditions")
                            }
                          >
                            Terms & Conditions
                          </MenuItem>
                          {ipBlockedPermission ? (
                            <MenuItem
                              className="mx-5 rounded-2 fs-5 py-3"
                              onClick={(e) =>
                                handleProfileRoutes("ip-blocked")
                              }
                            >
                              IP Blocked
                            </MenuItem>
                          ) : null}
                          <MenuItem
                            className="mx-5 rounded-2 fs-5 py-3"
                            onClick={handleLogout}
                          >
                            Logout
                          </MenuItem>
                        </Menu>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="d-flex align-items-center ms-3 d-xl-none d-lg-flex "
                title="Show aside menu"
                onClick={(e) => {
                  toggleSidebar(e);
                  toggleSidebarDesk(!sidebarDeskOpen);
                }}
              >
                <svg
                  className="custom-svg"
                  width="28"
                  height="28"
                  viewBox="0 0 384 300"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="#344d95"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 22.0001C0 16.3421 2.24761 10.9159 6.24839 6.91514C10.2492 2.91436 15.6754 0.666748 21.3333 0.666748H362.667C368.325 0.666748 373.751 2.91436 377.752 6.91514C381.752 10.9159 384 16.3421 384 22.0001C384 27.658 381.752 33.0842 377.752 37.085C373.751 41.0858 368.325 43.3334 362.667 43.3334H21.3333C15.6754 43.3334 10.2492 41.0858 6.24839 37.085C2.24761 33.0842 0 27.658 0 22.0001ZM0 150C0 144.342 2.24761 138.916 6.24839 134.915C10.2492 130.914 15.6754 128.667 21.3333 128.667H234.667C240.325 128.667 245.751 130.914 249.752 134.915C253.752 138.916 256 144.342 256 150C256 155.658 253.752 161.084 249.752 165.085C245.751 169.086 240.325 171.333 234.667 171.333H21.3333C15.6754 171.333 10.2492 169.086 6.24839 165.085C2.24761 161.084 0 155.658 0 150ZM0 278C0 272.342 2.24761 266.916 6.24839 262.915C10.2492 258.914 15.6754 256.667 21.3333 256.667H128C133.658 256.667 139.084 258.914 143.085 262.915C147.086 266.916 149.333 272.342 149.333 278C149.333 283.658 147.086 289.084 143.085 293.085C139.084 297.086 133.658 299.333 128 299.333H21.3333C15.6754 299.333 10.2492 297.086 6.24839 293.085C2.24761 289.084 0 283.658 0 278Z"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>

        <Snackbar
          open={snackbar.open}
          autoHideDuration={2000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert onClose={handleCloseSnackbar} severity={snackbar.severity}>
            <Typography variant="body1" style={{ fontWeight: "bold" }}>
              {snackbar.message}
            </Typography>
          </Alert>
        </Snackbar>
      </div>
      {<SideBarComponent isSandbox={isSandbox} />}
    </>
  );
};

export default HeaderComponent;
